// src/lib/schemas/invoice.schema.ts
import * as Yup from 'yup';

export const invoiceItemSchema = Yup.object().shape({
  itemId: Yup.string().required('Item is required'),
  quantity: Yup.number().min(1, 'Quantity must be at least 1').required('Quantity is required'),
  rate: Yup.number().min(0, 'Rate must be positive').required('Rate is required'),
  taxRate: Yup.number().min(0).default(0),
  taxValue: Yup.string().required('Tax selection is required'),
  amount: Yup.number().min(0).default(0),
});

export const invoiceSchema = Yup.object().shape({
  invoiceNumber: Yup.string()
    .min(1, 'Invoice number is required')
    .required('Invoice number is required'),
  status: Yup.string().oneOf(['sent', 'paid'], 'Invalid status').default('sent'),
  invoiceDate: Yup.string().required('Invoice date is required'),
  dueDate: Yup.string().required('Due date is required'),
  terms: Yup.string().default('Immediate'),
  invoiceTitleType: Yup.string().default('tax_invoice'),
  paymentSource: Yup.string(),
  placeOfSupply: Yup.string().required('Place of supply is required'),
  companyId: Yup.string(),
  customerId: Yup.string().required('Customer is required'),
  individualName: Yup.string()
    .max(30, 'Name cannot exceed 30 characters')
    .when('companyId', {
      is: (val: string) => !val || val.trim() === '',
      then: (schema) => schema.required('Individual name is required when no company is selected'),
      otherwise: (schema) => schema.notRequired(),
    }),
  selectedBankId: Yup.string(),
  currency: Yup.string().default('INR'),
  branding: Yup.boolean().default(true),
  items: Yup.array()
    .of(invoiceItemSchema)
    .min(1, 'At least one item is required')
    .required('Items are required'),
});
